//antispam filling default value
const els = document.getElementsByName("antirobot");

els.forEach(input => {
	input.value = "stop-spamming-us";
})
